module.exports = __webpack_public_path__ + "img/sebrae-ba-logo.png_color1.d19f88d3.png";